export const LOGO_URL = '/images/govinity-square-logo-white.png';

export const FULL_LOGO_URL_LIGHT = '/images/govinity-lowercase-logo-black.png';
export const FULL_LOGO_URL_DARK = '/images/govinity-lowercase-logo-gold.png';

export const NEW_FULL_LOGO_URL_LIGHT = '/images/full-logo-dark-on-white.svg';
export const NEW_FULL_LOGO_URL_DARK = '/images/full-logo-white-on-dark.svg';

export const SOCIAL_PREVIEW_LOGO_URL = '/images/govinity-social-preview-logo.png';
